import React, { useCallback } from 'react'
import { IHistoryEvent } from '../../types/history'
import { IContinuationResponse } from '../../types/continuationScroll'
import { getPackHistory } from '../../services/pack'
import { DetailsTemplate } from '../../layouts'
import { HistoryEventList, ContinuationScroll } from '../../components'

interface IPackHistoryTab {
  packId?: string
  editionId?: string
}

export const PackHistoryTab = ({ packId, editionId }: IPackHistoryTab) => {
  const getItems = useCallback(
    (token?: string): Promise<IContinuationResponse<IHistoryEvent>> =>
      getPackHistory(packId, editionId, token),
    [packId, editionId]
  )
  return (
    <>
      <DetailsTemplate contentProps={{ id: 'pack-history-tab-main' }}>
        <ContinuationScroll
          getItems={packId ? getItems : undefined}
          render={HistoryEventList}
        />
      </DetailsTemplate>
    </>
  )
}
